import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141'),
	() => import('./nodes/142'),
	() => import('./nodes/143'),
	() => import('./nodes/144'),
	() => import('./nodes/145'),
	() => import('./nodes/146'),
	() => import('./nodes/147'),
	() => import('./nodes/148'),
	() => import('./nodes/149'),
	() => import('./nodes/150'),
	() => import('./nodes/151'),
	() => import('./nodes/152'),
	() => import('./nodes/153'),
	() => import('./nodes/154'),
	() => import('./nodes/155'),
	() => import('./nodes/156'),
	() => import('./nodes/157'),
	() => import('./nodes/158'),
	() => import('./nodes/159'),
	() => import('./nodes/160'),
	() => import('./nodes/161'),
	() => import('./nodes/162'),
	() => import('./nodes/163'),
	() => import('./nodes/164'),
	() => import('./nodes/165'),
	() => import('./nodes/166'),
	() => import('./nodes/167'),
	() => import('./nodes/168'),
	() => import('./nodes/169'),
	() => import('./nodes/170')
];

export const server_loads = [];

export const dictionary = {
		"/[[lang=locale]]/(index-page)": [43,[2],[3]],
		"/[[lang=locale]]/(non-auth)/accept-invite": [163,[2,40],[3]],
		"/[[lang=locale]]/(need-unauth)/account-recovery": [148,[2,37],[3]],
		"/[[lang=locale]]/error": [170,[2],[3]],
		"/[[lang=locale]]/(non-auth)/esign": [164,[2,40,41],[3]],
		"/[[lang=locale]]/(non-auth)/esign/auth": [165,[2,40,41],[3]],
		"/[[lang=locale]]/(non-auth)/esign/exit": [166,[2,40,41],[3]],
		"/[[lang=locale]]/(non-auth)/esign/exit/[token]": [167,[2,40,41],[3]],
		"/[[lang=locale]]/(non-auth)/like-reload": [168,[2,40],[3]],
		"/[[lang=locale]]/(non-auth)/login/sso/[ssoPartnerType]": [169,[2,40],[3]],
		"/[[lang=locale]]/(need-auth)/logout": [123,[2,4],[3]],
		"/[[lang=locale]]/(need-unauth)/reset-password-from-email": [149,[2,37],[3]],
		"/[[lang=locale]]/(need-auth)/reset-password-or-postpone": [124,[2,4],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-in": [150,[2,37,38],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/callback-cue-sign-up": [151,[2,37],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct": [152,[2,37,39],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/complete": [153,[2,37,39],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/email-input": [154,[2,37,39],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/set-password": [155,[2,37,39],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/terms": [156,[2,37,39],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/user-name": [157,[2,37,39],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/verify-code": [158,[2,37,39],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/invite": [159,[2,37],[3]],
		"/[[lang=locale]]/(need-auth)/sso-sign-in-callback": [125,[2,4],[3]],
		"/[[lang=locale]]/(need-unauth)/sso-sign-up-callback": [160,[2,37],[3]],
		"/[[lang=locale]]/(need-unauth)/sso-sign-up-closed": [161,[2,37],[3]],
		"/[[lang=locale]]/(need-unauth)/super-admin": [162,[2,37],[3]],
		"/[[lang=locale]]/(need-auth)/su": [126,[2,4,32],[3]],
		"/[[lang=locale]]/(need-auth)/su/allibee-users": [127,[2,4,32,33],[3]],
		"/[[lang=locale]]/(need-auth)/su/allibee-users/all-users": [128,[2,4,32,33],[3]],
		"/[[lang=locale]]/(need-auth)/su/allibee-users/expert-applicants": [129,[2,4,32,33],[3]],
		"/[[lang=locale]]/(need-auth)/su/allibee-users/form": [130,[2,4,32,33],[3]],
		"/[[lang=locale]]/(need-auth)/su/contract-template": [131,[2,4,32],[3]],
		"/[[lang=locale]]/(need-auth)/su/contract-template/[templateId]": [132,[2,4,32],[3]],
		"/[[lang=locale]]/(need-auth)/su/super-users": [133,[2,4,32],[3]],
		"/[[lang=locale]]/(need-auth)/su/terms": [134,[2,4,32],[3]],
		"/[[lang=locale]]/(need-auth)/su/terms/[id]": [135,[2,4,32],[3]],
		"/[[lang=locale]]/(need-auth)/su/voc/signing-link": [136,[2,4,32],[3]],
		"/[[lang=locale]]/(need-auth)/su/workflow-management": [137,[2,4,32,34],[3]],
		"/[[lang=locale]]/(need-auth)/su/workflow-management/[id]": [138,[2,4,32,34],[3]],
		"/[[lang=locale]]/(need-auth)/su/workspaces": [139,[2,4,32,35],[3]],
		"/[[lang=locale]]/(need-auth)/su/workspaces/form": [141,[2,4,32,35],[3]],
		"/[[lang=locale]]/(need-auth)/su/workspaces/[id]": [140,[2,4,32,35],[3]],
		"/[[lang=locale]]/(need-auth)/welcome": [142,[2,4],[3]],
		"/[[lang=locale]]/(need-auth)/workspace": [143,[2,4,36],[3]],
		"/[[lang=locale]]/(need-auth)/workspace/create": [144,[2,4,36],[3]],
		"/[[lang=locale]]/(need-auth)/workspace/create/company-info": [145,[2,4,36],[3]],
		"/[[lang=locale]]/(need-auth)/workspace/create/complete": [146,[2,4,36],[3]],
		"/[[lang=locale]]/(need-auth)/workspace/create/select-plan": [147,[2,4,36],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]": [44,[2,4,5],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/account/(with-sidebar)": [45,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/account/(with-sidebar)/language": [46,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/account/(with-sidebar)/profile": [47,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)": [48,[2,4,5,7,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/edit-permissions": [49,[2,4,5,7,8,9],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/notice": [50,[2,4,5,7,8,10],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/notice/form": [52,[2,4,5,7,8,10],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/notice/form/[id]": [53,[2,4,5,7,8,10],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/notice/[id]": [51,[2,4,5,7,8,10],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/payment": [54,[2,4,5,7,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/seal-management": [55,[2,4,5,7,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/user-list": [56,[2,4,5,7,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/user-list/[tab]": [57,[2,4,5,7,8,11],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/workspace-info": [58,[2,4,5,7,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/workspace-overview": [59,[2,4,5,7,8,12],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/workspace-overview/divisions": [60,[2,4,5,7,8,12],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/workspace-overview/positions": [61,[2,4,5,7,8,12],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/admin/(with-sidebar)/workspace-overview/titles": [62,[2,4,5,7,8,12],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/business-agent/(with-sidebar)": [63,[2,4,5,13,14],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/business-agent/(with-sidebar)/agent": [64,[2,4,5,13,14],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/business-agent/(with-sidebar)/chat": [65,[2,4,5,13,14],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/business-agent/(with-sidebar)/db-management": [66,[2,4,5,13,14],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/business-agent/legislation": [70,[2,4,5,13],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/business-agent/(with-sidebar)/review": [67,[2,4,5,13,14],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/business-agent/(with-sidebar)/search": [68,[2,4,5,13,14,15],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/business-agent/(with-sidebar)/workflow": [69,[2,4,5,13,14],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)": [71,[2,4,5,16,17],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(lite)/ai-contracts": [72,[2,4,5,16,17,18],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(lite)/ai-contracts/drafts": [73,[2,4,5,16,17,18],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/approval": [82,[2,4,5,16,17,21],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/approval/draft/[contractId]": [96,[2,4,5,16,24],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/approval/[approvalId]": [95,[2,4,5,16,24],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/assignment": [83,[2,4,5,16,17,22],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/conhub": [97,[2,4,5,16],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/conhub/[contractId]": [98,[2,4,5,16],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(lite)/contracts": [74,[2,4,5,16,17,18],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(lite)/contracts/drafts": [75,[2,4,5,16,17,18],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(lite)/core-home": [76,[2,4,5,16,17,18],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/counterparty-list-management": [84,[2,4,5,16,17],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/home": [85,[2,4,5,16,17],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/my-request": [86,[2,4,5,16,17],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(new-contract)/new-contract-standard": [80,[2,4,5,16,17],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(new-contract)/new-contract-upload": [81,[2,4,5,16,17],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/repository": [87,[2,4,5,16,17],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/repository/contract-extract": [99,[2,4,5,16],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/repository/detail/[id]": [100,[2,4,5,16],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(lite)/repository/drafts": [77,[2,4,5,16,17,18,19],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/repository/reexecute-copy": [101,[2,4,5,16],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/seal-documents": [88,[2,4,5,16,17],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/seal-management": [89,[2,4,5,16,17],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(lite)/signing": [78,[2,4,5,16,17,18,20],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/(lite)/signing/drafts": [79,[2,4,5,16,17,18,20],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/template": [90,[2,4,5,16,17,23],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/template/custom": [91,[2,4,5,16,17,23],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/template/global": [92,[2,4,5,16,17,23],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/template/[templateId]": [102,[2,4,5,16],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/upload-signed-bulk": [94,[2,4,5,16,17],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/clm/(with-sidebar)/upload-signed": [93,[2,4,5,16,17],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)": [103,[2,4,5,25],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/advisory": [104,[2,4,5,25,26],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/advisory/new": [106,[2,4,5,25,26,28],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/advisory/[id]": [105,[2,4,5,25,26,27],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/assignment": [107,[2,4,5,25],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/home": [108,[2,4,5,25],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/lawfirm": [109,[2,4,5,25,29],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/lawfirm/[id]": [110,[2,4,5,25,29],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations": [111,[2,4,5,25],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/new": [121,[2,4,5,25],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/[id]": [112,[2,4,5,25,30],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/[id]/commentsAndRecords": [115,[2,4,5,25,30],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/[id]/email": [116,[2,4,5,25,30,31],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/[id]/email/[emailId]": [117,[2,4,5,25,30,31],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/[id]/expenseManagement": [118,[2,4,5,25,30],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/[id]/fileManagement": [119,[2,4,5,25,30],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/[id]/(supreme-court-connectable)/lawsuitGeneralContents": [113,[2,4,5,25,30],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/[id]/(supreme-court-connectable)/lawsuitProgressedContents": [114,[2,4,5,25,30],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/elm/(with-sidebar)/litigations/[id]/litigationRegistrationInformation": [120,[2,4,5,25,30],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/subscription-expired": [122,[2,4,5],[3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';